import { createFileRoute } from '@tanstack/react-router';
import { basicHead } from '../../utility/head';
import { FeatureArticle, featureSeo } from '../../components/FeatureArticle';
import { exportIntegrations } from '../../assets/data/features/export-integrations';

export const Route = createFileRoute('/_marketing/export-integrations')({
  component: () => <FeatureArticle data={exportIntegrations} />,
  ssr: true,
  loader: ({ location }) => ({
    pathname: location.pathname,
    seo: featureSeo(exportIntegrations),
  }),
  head: basicHead,
});
